import { styled } from '@mui/material/styles'
import TextField from '@mui/material/TextField'

export const StyledTextField = styled(TextField)(({ theme, multiline }) => ({
  /* background: theme.palette.other.grey, */
  width: '100%',
  '& .MuiInputBase-root': {
    background: theme.palette.other.grey,
    '& fieldset': {
      border: 0,
    },
    '&:hover fieldset': {
      border: 0,
    },
    '&.Mui-focused fieldset': {
      border: 0,
    },
  },
  '& .MuiInputBase-input': {
    backgroundColor: theme.palette.other.grey,
    height: multiline ? 'auto' : '3.6vh',
    fontSize: 'clamp(1em, 1.5em, 1em)',
  },
  '& .MuiFormHelperText-root': {
    fontSize: 'clamp(1em, 1.5em, 1em)',
  }
}))
